"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOM_LINK_KEY = exports.FORM_LINK_BUTTON_KEY = exports.LOCATION_KEY = exports.END_DATE_KEY = exports.DATE_KEY = exports.VIEW_TICKETS_KEY = exports.E_TICKET_KEY = exports.PREFILLED_FORM_KEY = exports.MAGICAL_LINK_KEY = exports.BUTTON_COLOR = exports.CUSTOM_LINK = exports.VARIABLE_TEXT = exports.PREFILLED_FORM_TYPE = exports.PREFILLED_FORM_ID = exports.VARIABLE_DATA_ATTR = void 0;
// Custom html attribute that help to interpret custom variables (need to begin with "data-" and accepter in sanitizer)
exports.VARIABLE_DATA_ATTR = "data-custom-variable";
exports.PREFILLED_FORM_ID = "data-prefilled-form-id";
exports.PREFILLED_FORM_TYPE = "data-prefilled-form-type";
exports.VARIABLE_TEXT = "data-text";
exports.CUSTOM_LINK = "data-custom-link";
exports.BUTTON_COLOR = "data-button-color";
// Custom key that are added to the html values to differentiate different types of variables
exports.MAGICAL_LINK_KEY = "magical-link-variable";
exports.PREFILLED_FORM_KEY = "prefilled-form-variable";
exports.E_TICKET_KEY = "e-ticket-variable";
exports.VIEW_TICKETS_KEY = "view-tickets-variable";
// Kept start date variable name for backward compatibility
exports.DATE_KEY = "date-variable";
exports.END_DATE_KEY = "end-date-variable";
exports.LOCATION_KEY = "location-variable";
// Custom key for button
exports.FORM_LINK_BUTTON_KEY = "form-link-button";
exports.CUSTOM_LINK_KEY = "custom-link-button";
